import { render, staticRenderFns } from "./AddQuiz.vue?vue&type=template&id=a80df174&"
import script from "./AddQuiz.vue?vue&type=script&lang=js&"
export * from "./AddQuiz.vue?vue&type=script&lang=js&"
import style0 from "./AddQuiz.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports